import { Component, OnInit } from '@angular/core';
// import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';

import * as fromApp from '../../store/app.reducers';
import * as fromAuth from '../../auth/store/auth.reducers';
import * as AuthActions from '../../auth/store/auth.actions';
import * as EventActions from '../../events/store/event.actions';
import * as QuestionListActions from '../../question-list/store/question-list.actions';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  logoPath = '../../../assets/pictures/audeering-logo-tm-216x56.png';
  authState: Observable<fromAuth.State>;

  constructor(private store: Store<fromApp.AppState>) {
  }

  ngOnInit() {
    this.authState = this.store.select('auth');
  }

  onSaveData() {
    this.store.dispatch(new EventActions.StoreEvents());
    this.store.dispatch(new QuestionListActions.StoreQuestions());
  }

  onFetchData() {
    this.store.dispatch(new EventActions.FetchEvents());
  }

  onLogout() {
    this.store.dispatch(new AuthActions.Logout());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/header/header.component.ts